import { useEffect, useState } from "react";
import {
  AlertCircle,
  Calendar,
  CheckCircle,
  Download,
  RefreshCw,
} from "lucide-react";
import { getListLicenses } from "../../API/super-admin/LicenseApi";
import { useSelector } from "react-redux";
import Table from "../common/table/Table";
import { toast } from "react-toastify";
import DockerImageList from "./docker-details-list";

export default function LicenseDetails() {
  const { userInfo } = useSelector((state) => state.userLogin);

  const [isLoading, setIsLoading] = useState(false);
  const [licenses, setLicenses] = useState([]);
  const [licenseCurrentPage, setLicenseCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const handleRefresh = () => {
    setIsLoading(true);
    setTimeout(() => setIsLoading(false), 1500);
  };

  const getLicenses = async () => {
    setLoading(true);
    try {
      const data = await getListLicenses(
        userInfo?.organisation_id,
        userInfo.token
      );
      setLicenses(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.message || "Failed to get license");
    }
  };

  useEffect(() => {
    getLicenses();
  }, [userInfo?.organisation_id]);

  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case "active":
        return "text-green-600 bg-green-50";
      case "expiring soon":
        return "text-yellow-600 bg-yellow-50";
      default:
        return "text-gray-600 bg-gray-50";
    }
  };

  const handlePageChange = (page) => {
    setLicenseCurrentPage(page);
  };

  const pageSize = 10;
  const licensestotalItems = licenses?.length;

  const columnsTable = [
    {
      header: "Sl No",
      accessor: "_id",
      cell: (value, row, index) => {
        return index + 1;
      },
    },
    {
      header: "License Number",
      accessor: "licenseKey",
      cell: (value, row) => (
        <div className="text-sm font-medium text-gray-900 group-hover:text-red-600 transition-colors">
          {value}
        </div>
      ),
    },
    {
      header: "Start Date",
      accessor: "startDate",
      cell: (value) => (
        <div className="text-sm text-gray-600 flex items-center">
          <Calendar className="h-4 w-4 text-gray-400 mr-2" />
          {new Date(value).toLocaleDateString()}
        </div>
      ),
    },
    {
      header: "Expiry Date",
      accessor: "expiryDate",
      cell: (value) => (
        <div className="text-sm text-gray-600 flex items-center">
          <Calendar className="h-4 w-4 text-gray-400 mr-2" />
          {new Date(value).toLocaleDateString()}
        </div>
      ),
    },
    {
      header: "Status",
      accessor: "status",
      cell: (value) => (
        <span
          className={`py-1.5 text-sm font-medium text-center rounded-full ${getStatusColor(
            value
          )}`}
        >
          {value}
        </span>
      ),
    },

    {
      header: "Assigned To",
      accessor: "assignedTo",
      cell: (value) => <span>{value ? value : "Unassigned"}</span>,
    },
    {
      header: "Admin Name",
      accessor: "adminName",
    },
  ];

  return (
    <div className="grid gap-6 md:grid-cols-1">
      <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
        <div className="border-b border-gray-200 px-6 py-4">
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-semibold text-gray-900">
              License Information
            </h3>
          </div>
        </div>
        <div className="space-y-4 px-6 py-4">
          {/* <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-sm font-medium text-gray-500">License Type</p>
              <p className="text-lg font-semibold">Enterprise</p>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500">License ID</p>
              <p className="text-lg font-semibold">ENT-2023-8752</p>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500">Issue Date</p>
              <p className="text-lg font-semibold">Jan 15, 2023</p>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500">Expiry Date</p>
              <p className="text-lg font-semibold">Jan 15, 2025</p>
            </div>
          </div>

          <div>
            <div className="mb-1 flex items-center justify-between">
              <p className="text-sm font-medium text-gray-500">License Validity</p>
              <p className="text-sm font-medium">8 months remaining</p>
            </div>
            <div className="h-2 w-full overflow-hidden rounded-full bg-gray-200">
              <div className="h-full w-[67%] rounded-full bg-green-600"></div>
            </div>
          </div>

          <div>
            <p className="text-sm font-medium text-gray-500">Project Assignment</p>
            <p className="text-lg font-semibold">Cloud Migration Platform</p>
            <p className="text-sm text-gray-500">Used for production environment</p>
          </div> */}
          <Table
            columns={columnsTable}
            data={licenses}
            loading={loading}
            pagination={{
              currentPage: licenseCurrentPage,
              pageSize,
              totalItems: licensestotalItems,
              onPageChange: handlePageChange,
            }}
            className="bg-white rounded-lg shadow"
          />
        </div>
      </div>

      <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
        <div className="border-b border-gray-200 px-6 py-4">
          <h3 className="text-lg font-semibold text-gray-900">
            Docker Details
          </h3>
          <p className="text-sm text-gray-500">
            Available Docker versions for deployment
          </p>
        </div>
        {/* <div className="px-6 py-4">
          <div className="space-y-6">
            <div className="rounded-lg border border-green-200 bg-green-50 p-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <CheckCircle className="h-5 w-5 text-green-600" />
                  <span className="ml-2 font-medium text-green-800">Current Version (n)</span>
                </div>
                <span className="rounded-full bg-green-600 px-2.5 py-0.5 text-xs font-medium text-white">Active</span>
              </div>
              <div className="mt-2 pl-7">
                <p className="text-sm font-mono text-green-800">docker.company.com/platform:v3.2.1</p>
                <p className="mt-1 text-xs text-green-700">Released: April 1, 2023</p>
                <div className="mt-2 flex gap-2">
                  <span className="inline-flex items-center rounded-full bg-green-100 px-2.5 py-0.5 text-xs font-medium text-green-800">
                    Security Patched
                  </span>
                  <span className="inline-flex items-center rounded-full bg-green-100 px-2.5 py-0.5 text-xs font-medium text-green-800">
                    Performance Optimized
                  </span>
                </div>
              </div>
            </div>

            <div className="rounded-lg border border-gray-200 bg-gray-50 p-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <span className="ml-2 font-medium text-gray-800">Previous Version (n-1)</span>
                </div>
                <span className="rounded-full bg-gray-600 px-2.5 py-0.5 text-xs font-medium text-white">Available</span>
              </div>
              <div className="mt-2 pl-7">
                <p className="text-sm font-mono text-gray-800">docker.company.com/platform:v3.1.5</p>
                <p className="mt-1 text-xs text-gray-700">Released: February 15, 2023</p>
                <div className="mt-2 flex gap-2">
                  <span className="inline-flex items-center rounded-full bg-gray-200 px-2.5 py-0.5 text-xs font-medium text-gray-800">
                    Legacy Support
                  </span>
                </div>
              </div>
            </div>

            <div className="rounded-lg border border-gray-200 bg-gray-50 p-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <span className="ml-2 font-medium text-gray-800">Older Version (n-2)</span>
                </div>
                <span className="rounded-full bg-amber-600 px-2.5 py-0.5 text-xs font-medium text-white">
                  Deprecated
                </span>
              </div>
              <div className="mt-2 pl-7">
                <p className="text-sm font-mono text-gray-800">docker.company.com/platform:v3.0.8</p>
                <p className="mt-1 text-xs text-gray-700">Released: December 5, 2022</p>
                <div className="mt-2 flex gap-2">
                  <span className="inline-flex items-center rounded-full bg-amber-100 px-2.5 py-0.5 text-xs font-medium text-amber-800">
                    End of Support: May 1, 2023
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <DockerImageList userInfo={userInfo} />
        <div className="border-t border-gray-200 px-6 py-4">
          <div className="flex items-start gap-2 rounded-lg bg-amber-50 p-3 text-amber-800">
            <AlertCircle className="h-5 w-5 flex-shrink-0" />
            <div>
              <p className="font-medium">Docker Version Notice</p>
              <p className="text-sm">
                Older versions will be removed after their end-of-support date.
                Please update to the latest version.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
